import type { EntityValidationRules } from "../services/validationService";
import Enum, { EnumValidationRules } from "./enum";
import type RoadType from "./roadType";

export default class Road extends Enum {
  regionIds: string[] = [];
  roadType: RoadType;
}

export const RoadValidationRules: EntityValidationRules<Road> = {
  ...EnumValidationRules,
  roadType: {
    required: true,
  },
};
